/* RESPONSIBLE TEAM: team-ml */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import AdminSummary, { type AdminSummaryWireFormat } from '../admin-summary';

interface PlanTask {
  id: string;
  title: string;
  description?: string;
  done: boolean;
}

interface PlanPhase {
  name: string;
  tasks: PlanTask[];
}

interface PlanData {
  phases: PlanPhase[];
  updated_at?: string;
}

interface GeneratedPlanWireFormat {
  renderable_type: RenderableType;
  entity?: AdminSummaryWireFormat;
  plan_data?: PlanData;
}

export default class GeneratedPlan implements RenderableData {
  readonly renderableType: RenderableType = RenderableType.GeneratedPlan;
  readonly entity?: AdminSummary;
  readonly planData?: PlanData;

  constructor(entity?: AdminSummary, planData?: PlanData) {
    this.entity = entity;
    this.planData = planData;
  }

  get creatingEntity() {
    if (this.entity) {
      return {
        type: EntityType.Bot,
        id: this.entity.id,
        object: this.entity,
      };
    }
    return { type: EntityType.Bot, id: -1 };
  }

  static deserialize(json: GeneratedPlanWireFormat): GeneratedPlan {
    let entity = json.entity ? AdminSummary.deserialize(json.entity) : undefined;
    return new GeneratedPlan(entity, json.plan_data);
  }
}
